import React, { useEffect, useState } from "react";
import FleetTable from "../../components/Admin/Fleets/FleetTable";
import {
  fetchFleets,
  deleteFleet,
  updateFleet,
} from "../../services/fleetService";
import { toast } from "react-hot-toast";

const FleetManagement = () => {
  const [fleets, setFleets] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadFleets = async () => {
    try {
      const res = await fetchFleets();
      if (res.data.status === "success") {
        setFleets(res.data.data);
      } else {
        toast.error("Failed to load fleets");
      }
    } catch (err) {
      toast.error("Error loading fleets");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFleets();
  }, []);


  const handleToggleActive = async (fleetId) => {
    const fleet = fleets.find((f) => f._id === fleetId);
    if (!fleet) return;
    try {
      const updatedFleet = { ...fleet, isActive: !fleet.isActive };
      const res = await updateFleet(fleetId, updatedFleet);
      if (res.data.status === "success") {
        toast.success("Fleet updated");
        loadFleets();
      } else {
        toast.error("Failed to update fleet");
      }
    } catch (err) {
      toast.error("Error toggling fleet status");
    }
  };

  const handleDelete = async (fleetId) => {
    try {
      const res = await deleteFleet(fleetId);
      if (res.data.status === "success") {
        toast.success("Fleet deleted");
        loadFleets();
      } else {
        toast.error("Failed to delete fleet");
      }
    } catch (err) {
      toast.error("Error deleting fleet");
    }
  };

  return (
    <div>
      {loading ? (
        <div className="p-4 text-center">Loading fleets...</div>
      ) : (
        <FleetTable
          fleets={fleets}
          onFleetAdded={loadFleets}
          onToggleActive={handleToggleActive}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
};

export default FleetManagement;
